export const parseDateFromString = (dateString: string): Date => {
  const [year, month, day] = dateString.split('-');
  const parsedDate = new Date(+year, +month - 1, +day, 0, 0, 0, 0);

  return parsedDate;
};
